import { Page } from '@app/components/page/Page';
import { GlobalReportsBreadcrumbs } from '@app/modules/audit/modules/global-audit/components/GlobalReportsBreadcrumbs';
import { ReportsViewPageSkeleton } from '@app/modules/audit/modules/global-audit/screens/common/ReportsViewPageSkeleton';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useAuditReportsFindOneReportRunsCatalog } from '@mi-front/api-v2';
import { QueryView } from '@mi-front/ui';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { Redirect, useParams } from 'react-router-dom';
import { BroadcastEvidenceReportDetail } from './BroadcastEvidenceReportDetail';

/**
 * Route page that loads and displays a broadcast evidence report run.
 * Gated by `app__audit_reports_broadcast_evidence_enabled`.
 */
export function BroadcastEvidenceReportPage() {
  const isBroadcastEvidenceEnabled = useFeatureIsOn(
    'app__audit_reports_broadcast_evidence_enabled',
  );
  const { id: reportId = '' } = useParams<{ id: string }>();
  const reportQuery = useAuditReportsFindOneReportRunsCatalog(reportId, {
    query: { enabled: isBroadcastEvidenceEnabled && Boolean(reportId) },
  });

  if (!isBroadcastEvidenceEnabled) {
    return <Redirect to="/audit/saved-reports/gip" />;
  }

  return (
    <QueryView query={reportQuery} loader={<ReportsViewPageSkeleton />}>
      {(report) => (
        <Page htmlTitle={report.name}>
          <Page.Header
            title={report.name}
            icon={<DescriptionOutlinedIcon />}
            breadcrumbs={<GlobalReportsBreadcrumbs showCreatedReports reportType={report.type} />}
          />
          <Page.Content>
            <BroadcastEvidenceReportDetail report={report} />
          </Page.Content>
        </Page>
      )}
    </QueryView>
  );
}
